import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseClient } from '../BaseClient';
export class CalendarOAuthClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "contactCalendarConnectionStatusImpl", void 0);
    _defineProperty(this, "revokeTokenForBusinessImpl", void 0);
    _defineProperty(this, "revokeTokenForContactImpl", void 0);
    _defineProperty(this, "getCalendarOAuthUrlImpl", void 0);
    _defineProperty(this, "getIndividualCalendarOAuthUrlImpl", void 0);
    _defineProperty(this, "googleAuthenticateImpl", void 0);
    _defineProperty(this, "connectICloudCalendarImpl", void 0);
  }
  getServiceNameForLogs() {
    return 'CalendarOAuthClientBase';
  }
  async getContactCalendarConnectionStatus(authToken) {
    try {
      this.logInfo('getContactCalendarConnectionStatus', 'entry');
      for (var _len = arguments.length, extraParam = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        extraParam[_key - 1] = arguments[_key];
      }
      const {
        connected
      } = await this.request(this.contactCalendarConnectionStatusImpl({
        authToken
      }), ...extraParam);
      return {
        isConnected: Boolean(connected)
      };
    } catch (error) {
      this.logError('getContactCalendarConnectionStatus', 'Failed to get contact calendar connection status', {
        authToken
      }, error);
      throw error;
    }
  }
  async revokeTokenForBusiness(tokenId) {
    try {
      this.logInfo('revokeTokenForBusiness', 'entry');
      for (var _len2 = arguments.length, extraParam = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        extraParam[_key2 - 1] = arguments[_key2];
      }
      await this.request(this.revokeTokenForBusinessImpl({
        tokenId
      }), ...extraParam);
    } catch (error) {
      this.logError('revokeTokenForBusiness', 'Failed to revoke token for business', {
        tokenId
      }, error);
      throw error;
    }
  }
  async revokeTokenForClient(authToken) {
    try {
      this.logInfo('revokeTokenForClient', 'entry');
      for (var _len3 = arguments.length, extraParam = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        extraParam[_key3 - 1] = arguments[_key3];
      }
      await this.request(this.revokeTokenForContactImpl({
        authToken
      }), ...extraParam);
    } catch (error) {
      this.logError('revokeTokenForClient', 'Failed to revoke token for client', {
        authToken
      }, error);
      throw error;
    }
  }
  async getCalendarOAuthUrl(provider, authToken) {
    try {
      this.logInfo('getCalendarOAuthUrl', 'entry');
      for (var _len4 = arguments.length, extraParam = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        extraParam[_key4 - 2] = arguments[_key4];
      }
      const {
        oauthUrl
      } = await this.request(this.getCalendarOAuthUrlImpl({
        provider,
        authToken
      }), ...extraParam);
      if (!oauthUrl) {
        throw new Error(`Failed to get url oauthUrl=${oauthUrl}`);
      }
      return oauthUrl;
    } catch (error) {
      this.logError('getCalendarOAuthUrl', 'Failed to get calendar OAuth URL', {
        provider,
        authToken
      }, error);
      throw error;
    }
  }
  async getIndividualCalendarOAuthUrl(provider) {
    try {
      this.logInfo('getIndividualCalendarOAuthUrl', 'entry');
      for (var _len5 = arguments.length, extraParam = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        extraParam[_key5 - 1] = arguments[_key5];
      }
      const {
        oauthUrl
      } = await this.request(this.getIndividualCalendarOAuthUrlImpl({
        provider
      }), ...extraParam);
      if (!oauthUrl) {
        throw new Error(`Failed to get url oauthUrl=${oauthUrl}`);
      }
      return oauthUrl;
    } catch (error) {
      this.logError('getIndividualCalendarOAuthUrl', 'Failed to get individual calendar OAuth URL', {
        provider
      }, error);
      throw error;
    }
  }
  async googleAuthenticate(authCode) {
    try {
      this.logInfo('googleAuthenticate', 'entry');
      for (var _len6 = arguments.length, extraParam = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        extraParam[_key6 - 1] = arguments[_key6];
      }
      await this.request(this.googleAuthenticateImpl({
        authCode
      }), ...extraParam);
    } catch (error) {
      this.logError('googleAuthenticate', 'Failed to google authenticate', {
        authCode
      }, error);
      throw error;
    }
  }
  async connectICloudCalendar(appleId, appSpecificPassword) {
    try {
      this.logInfo('connectICloudCalendar', 'entry');
      for (var _len7 = arguments.length, extraParam = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
        extraParam[_key7 - 2] = arguments[_key7];
      }
      const result = await this.request(this.connectICloudCalendarImpl({
        appleId,
        appSpecificPassword
      }), ...extraParam);
      return {
        tokenId: result.tokenId,
        email: result.email
      };
    } catch (error) {
      this.logError('connectICloudCalendar', 'Failed to connect iCloud calendar', {
        appleId
      }, error);
      throw error;
    }
  }
  convertToEntity(_data) {
    throw new Error('convertToEntity method should not be used in this context.');
  }
}
//# sourceMappingURL=CalendarOAuthClientBase.js.map